import img1 from '../images/01.jpg'
import img2 from '../images/02.jpg'
import img3 from '../images/03.jpg'


    const Date = [
        
        {
            img: img1,
            title: 'Rainbow Vegetable Sandwich',
            time: 'Time: 15 - 20 Minutes | Serves: 1',
            price: '10.00$'
        },

        {
            img: img2,
            title: 'Vegetarian Burger',
            time: 'Time: 30 - 45 Minutes | Serves: 1',
            price: '20.00$'
        },

        {
            img: img3,
            title: 'Vegetarian Burger',
            time: 'Time: 10 - 15 Minutes | Serves: 1',
            price: '15.00$'
        }

    ]

export default Date